import { useEffect, useState } from "react";
import styles from "./list.module.css";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Snackbar, Alert, Checkbox } from "@mui/material";
import { StyledMainTableCell } from "../../../components/TableComponent";
import TablePaginationComponent from "../../../components/TablePagination";
import { Close } from "@mui/icons-material";
import { Calendar, Search } from "react-feather";
import axios from "axios";
import Loader from "../../../components/Loader";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import TableCustomRow from "./TableCustomRow";
import PickedItemsLoader from "./PickedItemsLoader";
import { DateRangePicker } from "rsuite";
import dayjs from "dayjs";
import PageHeader from "../../../components/PageHeader";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";

const PickedUpItems = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", status: "", date: null });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [selected, setSelected] = useState([]);

  const { websiteData } = useWebsite();
  useSiteBranding("Picked Items", websiteData);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchBookings = () => {
      setContentLoading(true);

      axios.get(process.env.REACT_APP_API_URL + "v1/picked-item", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchBookings();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item.booking_id.toLowerCase().includes(inputVal) || item.customer_name.toLowerCase().includes(inputVal) || item.post_code.toLowerCase().includes(inputVal) || item.created_user.toLowerCase().includes(inputVal));
      });
    }

    if (filterVars?.date) {
      filterredTempData = filterredTempData.filter((i) => dayjs(i?.pickup_date).isBetween(dayjs(filterVars?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const selectRowEvent = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  }

  const reciveByBookIds = () => {
    if (selected.length === 0) {
      setSnackbarType("error");
      setSnackbarOpen(true);
      setSnackbarMessage("Please select booking");

      return false;
    }

    let selectedBooks = allData?.filter(i => selected?.indexOf(i?.id) > -1);

    let selectedIds = [];

    selectedBooks.forEach(i => {
      i?.products.forEach(p => {
        if (p?.is_wh_received === 0)
          selectedIds.push(p?.id);
      })
    });

    if (selectedIds.length) {
      makeReceivedNew(selectedIds);
    }
  }

  const makeReceivedNew = (item) => {
    setLoading(true);

    let postData = { bookingPIds: item };
    axios.post(process.env.REACT_APP_API_URL + "v1/make-as-received-new", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios(process.env.REACT_APP_API_URL + "v1/picked-item", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            let allData = response.data.data;
            setLoading(false);
            setSnackbarType("success");
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setAllData(allData);
          } else {
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={styles.MainDiv}>
      <PageHeader title="Booking" trail={[{ label: 'Picked Items' }]} />
      <div className={styles.MainCard}>
        {contentLoading && <PickedItemsLoader rows={6} />}

        {!contentLoading && (<>
          <div className={styles.TableFilterHead}>
            <div className={styles.SearchWrap}>
              <Search className={styles.SearchIcon} />
              <TextField
                variant="standard"
                type="text"
                placeholder="Search picked items"
                value={filterVars?.searchKey}
                onChange={(e) => setFilterVars((prev) => ({ ...prev, searchKey: e.target.value }))}
                className={styles.SearchInput}
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
              {filterVars?.searchKey !== "" && (
                <Button type="button" className={styles.ClearBU} onClick={(e) => setFilterVars((prev) => ({ ...prev, searchKey: "" }))}>
                  <Close />
                </Button>
              )}
            </div>

            <div className={styles.TableFilterBUSec}>
              <div className={styles.DateFilterWrap}>
                <DateRangePicker
                  format={"dd/MM/yyyy"}
                  placement={"bottomEnd"}
                  placeholder="Search by date"
                  caretAs={Calendar}
                  showOneCalendar
                  value={filterVars?.date}
                  onChange={(e) => setFilterVars((prev) => ({ ...prev, date: e }))}
                />
              </div>

              <Button className={styles.ReceiveAllBU} onClick={(e) => reciveByBookIds()}>Receive all</Button>
            </div>
          </div>

          <div className={styles.TableScrollWrap}>
            <TableContainer component={Paper} className={styles.ResponsiveTableWrap}>
              <Table sx={{ minWidth: 650 }} aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell padding="checkbox">
                      <Checkbox
                        className={styles.AllCheckbox}
                        color="primary"
                        indeterminate={selected?.length > 0 && selected?.length < filteredData?.length}
                        checked={filteredData?.length > 0 && selected?.length === filteredData?.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newSelected = filteredData.map((n) => n.id);
                            setSelected(newSelected);
                            return;
                          }
                          setSelected([]);
                        }}
                      />
                    </StyledMainTableCell>
                    <StyledMainTableCell>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell>Customer Name</StyledMainTableCell>
                    <StyledMainTableCell>Pickup Address</StyledMainTableCell>
                    <StyledMainTableCell>Pickup Date</StyledMainTableCell>
                    <StyledMainTableCell></StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => {
                    const isItemSelected = selected.indexOf(item?.id) !== -1;
                    return <TableCustomRow key={item?.id} item={item} isItemSelected={isItemSelected} selectRowEvent={selectRowEvent.bind(this)} makeReceivedNew={makeReceivedNew.bind(this)} />;
                  })}

                  {filteredData.length === 0 && (<TableRow>
                    <TableCell colSpan={10} align="center">No data found</TableCell>
                  </TableRow>)}
                </TableBody>

                {filteredData?.length > 0 && (<TableFooter>
                  <TableRow>
                    <TablePaginationComponent
                      count={filteredData?.length}
                      colSpan={6}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={
                        paginationChangeRowsPerPage
                      }
                    />
                  </TableRow>
                </TableFooter>)}
              </Table>
            </TableContainer>
          </div>
        </>)}
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>
  );
};

export default withAdminAuth(PickedUpItems);